import React from 'react';

import {
  Filter, Box, useWindowSize, Card,
} from 'vindi-ds-components';

import tokens from 'vindi-ds-tokens';

import useFilterCharges from '../hooks/useFilterCharges';
import FiltersCharges from './filters';
import CardsCharges from './cards';
import ModalExport from './modal-export';
import TableCharges from './table';
import TableCardCharges from './table_card';

const ListComponent = ({ charges }) => {
  const { isMobile } = useWindowSize();
  const RootContainer = isMobile ? React.Fragment : Card;
  const Table = isMobile ? TableCardCharges : TableCharges;

  return (
    <RootContainer noShadow>
      <Table charges={charges} />

      <Box px={2} pb={3} bgcolor={!isMobile && tokens.color.prsm.neutral['000'].value}>
        <Filter.Pagination />
      </Box>
    </RootContainer>
  );
};

const ListCharges = () => {
  const {
    listing,
    modalDownloadRef,
    filterFields,
  } = useFilterCharges();
  const { isLoading, status } = listing.query;

  const handleClickDownload = () => modalDownloadRef.current.open();

  if (isLoading || status === 'idle' || filterFields === null) {
    return null;
  }

  const { data } = listing.query;

  return (
    <Filter.FilterProvider {...listing}>

      <CardsCharges data={data} />

      <FiltersCharges
        onClickDownload={handleClickDownload}
        filterFields={filterFields}
      />

      <ListComponent charges={data.charges} />

      <ModalExport modalRef={modalDownloadRef} />
    </Filter.FilterProvider>
  );
};

export default ListCharges;
